import React, { useState, useContext, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, TextField as MuiTextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, useMediaQuery, Avatar, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import {
	List, Datagrid, TextField, FunctionField, Button as RaButton,
	useRefresh, SimpleList, SimpleForm, Create, TextInput, useRedirect, SelectInput, useInput
} from 'react-admin';
import { useSelector, useDispatch } from "react-redux";
import queryString from 'query-string';
import CustomExportButton from "./components/CustomExportButton";
import config from './config.json';
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, KeyboardTimePicker,KeyboardDatePicker } from "@material-ui/pickers";
// import DateTimePickerToolbar from "./components/DateTimePickerToolbar";
import EditIcon from '@material-ui/icons/Edit';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { translate, crudUpdate } from 'ra-core';
import { vehicleSvgs, hideMobileNumber, hideVehicleNumber, hideName, AnalyticDistributionImgs } from "./sharedData";
import { customTheme } from './customTheme';
// import SortOption from "./components/SortOption";
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Link } from "react-router-dom";
import CustomSearch from './components/CustomSearch';
import CustomFilter from './components/CustomFilter';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import { ContextProvider } from './globalContextProvider';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
// import DeleteIcon from '@material-ui/icons/Delete';
import { saveTokens } from './utils/saveTokens';
import PaymentIcon from '@material-ui/icons/Payment';
import notify from './components/CustomUseNotify';
import CustomDeleteButton from './CustomDeleteButton';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import RaAutocompleteInput from './components/RaAutocompleteInput';
import { Helmet } from "react-helmet";
import CustomCreateButton from './components/CustomCreateButton';
import RaDateInput from './components/RaDateInput';
import RaGenderInput from './components/RaGenderInput';
import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import QrCodeImg from './images/qr_code.png'
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import PSBLogo from './images/ps_pdf_logo.png';
import PrintIcon from '@material-ui/icons/Print';

const useStyles = makeStyles({
	list: {
		marginBottom: 0,
	},
	loaderContainer: {
		display: "flex",
		flex: 1,
		alignItems: "center",
		justifyContent: "center",
	},
	parkingSelectorContainer: {
		display: "grid",
		justifyContent: "space-between",
	},
	asyncSelector: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		paddingRight: 5,
	},
	timeFilterContainer: {
		alignItems: "center",
	},
	timeFilterButton: {
		marginLeft: "1%",
		width: "10%",
		minWidth: 85
	},
	searchParamsTitle: {
		fontSize: "1.05rem",
	},
	searchParams: {
		fontFamily: "Poppins-Regular",
		fontSize: "0.95rem",
	},
	listToolbar: {
		alignItems: "flex-end",
		marginTop: 10
	},
	chipCell: {
		textAlign: "center",
		padding: customTheme.spacing(1, 2),
		display: "block",
		borderRadius: 50,
		minWidth: 100,
	},
	statusCircle: {
		width: 7,
		height: 7,
		borderRadius: 10,
	},
	dialogPaper: {
		borderRadius: 15,
		padding: "15px 15px 15px",
		maxWidth: 350
	},
});

const MONTHLY_PASS_COLUMNS = {
	"Parking Name": false,
	"Price": false,
	"Issue On": false,
	"Issued By": false,
	"Pass Type": false,
	"Renewal Date": true,
	"Expiry Date": true,
	"Company Name": false
};

const CATEGORY = "MONTHLY PASS USER SECTION"

const renderAmount = (row, fieldName) => (`₹ ${parseFloat(row[fieldName])}`);
const renderVehicleType = (row) => (
	row.vehicle_type ?
		<div style={{ display: 'flex', alignItems: "center" }}>
			<img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 8 }} alt={row.vehicle_type_label} />
			{/* row.vehicle_type_label */}
		</div>
		:
		null
);

export function MonthlyPass(props) {
	const eventTracker = UseAnalyticsEvent()
	const classes = useStyles();
	const location = useLocation();
	const refresh = useRefresh();
	const listDataRef = useRef()
	const vehicleNumber = useSelector(state => state.searchText);
	const currentParking = useSelector(state => state.monthlyPassParking);
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const dispatch = useDispatch();
	const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
	const [allowEdit] = React.useState(sessionStorage.getItem("allow_edit_monthly_pass") === "1");
	const [allowRecharge] = React.useState(sessionStorage.getItem("allow_pass_recharge") === "1");
	const [allowDelete] = React.useState(sessionStorage.getItem("allow_pass_delete") === "1");
	// const [setAllowRedirect] = React.useState(true);
	const [displayColumns, setDisplayColumns] = useState(sessionStorage.getItem("monthlyPassUserColumns") ? JSON.parse(sessionStorage.getItem("monthlyPassUserColumns")) : MONTHLY_PASS_COLUMNS);
	//const [vehicleTypes, setVehicleTypes] = React.useState(Object.keys(featuresData.vehicle_type).map(type => ({ type, label: featuresData.vehicle_type[type].label, name: featuresData.vehicle_type[type].name })));
	const [startDateTime, setStartDateTime] = useState(null);
	const [endDateTime, setEndDateTime] = useState(null);
	const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
	const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
	const zoneIds = currentParking && currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
	const zoneLabels = currentParking && currentParking.zones ? currentParking.zones.split(";") : null;
	const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
		{ id, name: zoneLabels[index] }
	)) : null;
	if (finalZones)
		finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

	const queryParams = queryString.parse(props.location.search);
	let [prevSearch] = useState(queryParams && queryParams.vehicle_number ? {inputSearch: queryParams.vehicle_number, type: "Vehicle Number"} : sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "")
	const [search, setSearch] = useState(prevSearch.inputSearch)
	let searchTypeState = ["Vehicle Number", "Name", "Mobile", "Pass Type", "Issue By"]
	const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
	const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
	let filterTypesInitState = [

		{
			filterType: "Vehicle",
			dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		},
		{
			filterType: "Display Columns",
			dataList: { "Parking Name": false, "Issued On": false },
			listType: "CheckboxStatic",
			caseType: "CheckboxTypeStatic",
			showFilter: true,
			filterFormat: "Checkbox"
		},
	]

	const [settingFilterFormat, setSettingFilterFormat] = useState({})

	const filter = { ...settingFilterFormat, vehicle_number: vehicleNumber, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined }
	const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
	const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
	const [showPreview, setShowPreview] = useState(false);
	const [showPreviewDetails, setShowPreviewDetails] = useState(null);

	const download = (url) => {
        const tempLinkElement = document.createElement('a');
        tempLinkElement.target = "_blank";
        tempLinkElement.href = url;
        let filename;
        if (typeof url === "string") {
            const urlKeys = url.split("/");
            filename = urlKeys[urlKeys.length - 1];
        } else {
            filename = "Download";
        }
        tempLinkElement.setAttribute('download', filename);
        tempLinkElement.click();
    };

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        return moment(time).utcOffset("+05:30").format(`DD MMM YYYY ${use24HourFormat ? `HH:mm${secondsFormat} A` : `hh:mm${secondsFormat} a`}`)
	};

	const setCurrentParking = parking => {
		dispatch({
			type: "UPDATE_MONTHLY_PASS_PARKING",
			payload: {
				monthlyPassParking: parking,
			}
		});
	};

	const onParkingChange = (parking) => {
		setCurrentParking({ ...parking, allZones: true });
	};

	const onZoneChange = (event) => {
		setCurrentParking({
			...currentParking,
			id: event.target.value,
			name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
			allZones: event.target.value === "All"
		});
	};

	// const openVehicleLogs = (id, basePath, record) => `/monthlyPassLog?${queryString.stringify({ vehicle_number: record.vehicle_number })}`;

	const renderStatus = record => (
		<>
			{
				record ?
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: record.expiry_date > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59") ? `${customTheme.palette.primary.main}19` : `${customTheme.palette.error.main}19`, marginRight: 8 }}>
							<div className={classes.statusCircle} style={{ backgroundColor: record.expiry_date > moment().utcOffset("+05:30").format("YYYY-MM-DD 23:59:59") ? customTheme.palette.primary.main : customTheme.palette.error.main }} />
						</div>
						<p>{renderTime(record.expiry_date)}</p>
					</div>
					:
					<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, backgroundColor: "#9597991a", marginRight: 8 }}>
						<div className={classes.statusCircle} style={{ backgroundColor: "#1717181f" }} />
					</div>
			}
		</>
	);

	const getExportFile = (fileType) => {
		const {current : {total, currentSort, filterValues}} = listDataRef
		const params = {
			filter: JSON.stringify({ ...filter, ...filterValues }),
			sort: JSON.stringify([currentSort.field, currentSort.order]),
			page: 1,
			perPage: total,
			user_id: sessionStorage.getItem("user_id")
		};
		fetch(`${config.HOST_NAME}/crm/v3/monthlyPass?${queryString.stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Accept': `application/${fileType}`,
			},
		})
			.then(response => {
				saveTokens(response)
				return response.blob()
			})
			.then(blob => {
				const url = URL.createObjectURL(blob);
				const tempLinkElement = document.createElement('a');
				tempLinkElement.href = url;
				tempLinkElement.setAttribute('download', `${currentParking && currentParking.name ? currentParking.name : "Monthly Passes"}.${fileType}`);
				tempLinkElement.click();
			})
			.catch(error => {
				notify('Error Exporting Data', 'warning');
			});
	};

	const getExcelFile = () => {
		getExportFile("xlsx");
	};

	const getPDF = () => {
		getExportFile("pdf");
	};

	const BulkActionButtons = (props) => {
		const [open, setOpen] = React.useState(false);
		const [accessKeyId, setAccessKeyId] = useState("")
		const [loading, setLoading] = useState(false)

		const handleClickOpen = () => {
			setOpen(true);
		};

		const handleClose = () => {
			setOpen(false);
		};

		const onParkingSelect = async (accessKeyId) => {
			if (accessKeyId == null) {
				setAccessKeyId(null)
			}
			setAccessKeyId(accessKeyId)
		};

		const moveMonthlyPassHandler = () => {
			if (props.selectedIds.length !== 0) {

				if (accessKeyId == null || accessKeyId === "") {
					notify("Parking Name is Required", "warning")
					return;
				}

				fetch(`${config.HOST_NAME}/crm/v3/moveMonthlyPasses`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
						'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
					},
					body: JSON.stringify({
						monthly_pass_ids: props.selectedIds,
						access_key_id: accessKeyId
					}),
				})
					.then(response => {
						saveTokens(response)
						return response.json()
					})
					.then(json => {
						setLoading(false)
						if (json.success) {
							notify(json.message, "success");
							refresh()
							handleClose()
						} else {
							notify(json.message, "warning");
						}
					})
					.catch(error => {
						notify("Something went wrong", "warning");
						setLoading(false)
						console.log(error);
					});
			}
		}

		return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", columnGap: 1 }} >
			{
				props.selectedIds.length !== 0 &&
				<div>
					<RaButton label='Move' style={{ color: "#18cc69" }} onClick={handleClickOpen}>
						<SwapHorizIcon />
					</RaButton>
					<Dialog
						open={open}
						onClose={handleClose}
						classes={{ paper: classes.dialogPaper }}
					>

						<SimpleForm toolbar={false}>
							<dv className="grid-250">
								<div>
									<div className="formLabel-regular" style={{ fontWeight: "bold" }}>Parking Location*</div>
									<RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginBottom: 25 }} onSelect={onParkingSelect} />
									<p style={{ marginTop: -20 }}>Are you sure you want move these monthly passes to <strong>Selected Parking.</strong></p>
								</div>
							</dv>
						</SimpleForm>

						<DialogActions>
							<Button onClick={handleClose} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
								Cancel
							</Button>
							<Button onClick={moveMonthlyPassHandler} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
								Move {loading && <CircularProgress size={14} style={{ marginLeft: 15, color: "#fff" }} />}
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			}

		</div>
	}

	const setTimeFilters = () => {
		setStartDateTimeFilter(startDateTime);
		setEndDateTimeFilter(endDateTime);
	};

	const handleShowPreview = (record) => {
		setShowPreviewDetails(record)
		setShowPreview(true);
	  };
	
	  const handleClosePreview = () => {
		setShowPreview(false);
		setShowPreviewDetails(null);
	  };

	React.useEffect(() => {
		let values = {}
		// Add more types based on the filters
		if (filterListValue) {
			for (let val in filterListValue) {
				if (filterListValue[val].filterType === "Vehicle") {
					values = { ...values, vehicle_type: filterListValue[val].id ? filterListValue[val].id : undefined }
				}
				if (filterListValue[val].filterType === "Display Columns") {
					values = { ...values, columns: filterListValue[val].id ? filterListValue[val].id : undefined }
				}
			}
			setSettingFilterFormat(values)
		}
		if (filterListValue === null) {
			setSettingFilterFormat({})
		}
	}, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

	React.useEffect(() => {
		eventTracker(CATEGORY, "MONTHLY PASS USERS LIST")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className={classes.list}>
			<div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
				{showFilter &&
					<ParkingSearchSelector
						value={currentParking}
						onChange={onParkingChange}
						clearable={true}
						// filter={{ feature_monthly_pass: 1 }}
					/>
				}

				{currentParking && currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
					<FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
						<InputLabel>Zone Name</InputLabel>
						<Select
							value={currentParking.allZones ? "All" : currentParking.id}
							onChange={onZoneChange}
							label="Zone Name"
							variant="outlined"
						>
							<MenuItem value="All">All</MenuItem>
							{finalZones.map((zone, index) => (
								<MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
							))}
						</Select>
					</FormControl>
				}
			</div>
			{currentParking && <>
				<div className='customStyleForDataSearchDiv'>
					<CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
					<CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} defaultTime={false} />
					<CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} defaultColumns={MONTHLY_PASS_COLUMNS} storageKey="monthlyPassUserColumns" displayColumns={displayColumns} setDisplayColumns={setDisplayColumns} />
					{allowEdit && <CustomCreateButton label="Create Pass" basePath={props.basePath} resource={props.resource} />}
					<CustomExportButton getCSV={getExcelFile} getPDF={getPDF} disabled={listDataRef.current && listDataRef.current.total === 0} />
				</div>
				<List
					style={{marginTop: 20}}
					filter={filter}
					sort={{ field: "expiry_date", order: "DESC" }}
					empty={false}
					{...props}
					actions={false}
					bulkActionButtons={<BulkActionButtons />}
					pagination={<CustomPagination setListData={(listData) => {listDataRef.current = listData}}/>}
				>
					{isSmallDevice ?
						<SimpleList
							leftIcon={row => <Avatar alt={row.vehicle_type_label} src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow:"visible" }} />}
							primaryText={record => hideVehicleNumber(record.vehicle_number.toUpperCase())}
							secondaryText={record => (<div>
								<div style={{ color: customTheme.palette.secondary.main }}>{record.parking_name}</div>
								{record.name && <div><span style={{ color: "#5a5a5a" }}>Name: </span>{hideName(record.name)}</div>}
								{record.mobile_number && <div><span style={{ color: "#5a5a5a" }}>Mob No: </span>{hideMobileNumber(record.mobile_number)}</div>}
								{record.issued_by_user_id && <div><span style={{ color: "#5a5a5a" }}>Issued By: </span>{record.issued_by_user_id}</div>}
								{record.issue_time && <div><span style={{ color: "#5a5a5a" }}>Issued on: </span>{renderTime(record.issue_time)}</div>}
								{record.last_start_date && <div><span style={{ color: "#5a5a5a" }}>Renewal Date: </span>{renderTime(record.last_start_date)}</div>}
								{record.expiry_date && <div><span style={{ color: "#5a5a5a" }}>Expiry: </span>{renderTime(record.expiry_date)}</div>}
								{record.pass_type && <div><span style={{ color: "#5a5a5a" }}>Pass Type: </span>{record.pass_type}</div>}
								{record.price && record.price !== "" && !isNaN(record.price) && <div><span style={{ color: "#5a5a5a" }}>Price: </span>₹{parseFloat(record.price)}</div>}
								{record.organization_name && <div><span style={{ color: "#5a5a5a" }}>Company Name: </span>{record.organization_name}</div>}
								{!viewOnly && <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
									{allowRecharge && <RechargeButton {...props} record={record} />}
									<Link style={{ textDecoration: "none", cursor: "default" }} to={`/monthlyPassLog?${queryString.stringify({ vehicle_number: record.vehicle_number })}`}>
										<RaButton label="Log"><ListAltIcon /></RaButton>
									</Link>
									{allowEdit && <CustomEditButton {...props} record={record} />}
									{allowDelete && <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/monthlyPass'} />}
									<Button title='Print Pass' onClick={() => handleShowPreview(record)} style={{ color: "#334d6e" }} label={false}>
											<PrintIcon/>
										</Button>
								</div>}
							</div>)}
							linkType={false}
							rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
						/>
						:
						<Datagrid className='monthlyPassUsersDataGrid' component={ScrollableTable}>
							<FunctionField label="Vehicle number" render={record =>
								<div style={{ color: "#334d6e", fontWeight: "bold" }}>
									{record && record.vehicle_number ? hideVehicleNumber(record.vehicle_number.toUpperCase()) : '-'}
								</div>} />
							<FunctionField
								label="Vehicle Type"
								render={renderVehicleType}
							/>
							<FunctionField source="mobile_number" label="Mobile" render={record => record && record["mobile_number"] && record["mobile_number"] !== null ? hideMobileNumber(record.mobile_number): "-"} />
							<FunctionField source='name' label='Name' render={(record) => record && record.name ? hideName(record.name) : '-'} />
							{displayColumns["Parking Name"] && <TextField source="parking_name" sortable={false} />}
							{displayColumns["Issued By"] && <TextField source="issued_by_user_id" label="Issued By" />}
							{displayColumns["Issue On"] && <FunctionField source="issue_time" label="Issued on" render={record => record && record.issue_time ? renderTime(record.issue_time) : '-'} />}
							{displayColumns["Renewal Date"] && <FunctionField source="last_start_date" label="Renewal Date" render={record => record && record.last_start_date ? renderTime(record.last_start_date) : '-'} />}
							{displayColumns["Expiry Date"] && <FunctionField
								source="expiry_date"
								label="Validity"
								render={record => record && renderStatus(record)}
							/>}
							{displayColumns["Price"] && <FunctionField label="Price" source="price" render={(record) => renderAmount(record, "price")} sortable={true} />}
							{displayColumns["Pass Type"] && <TextField source="pass_type" sortable={false} />}
							{displayColumns["Company Name"] && <TextField source="organization_name" label="Company Name" sortable={false} />}
							{!viewOnly && <FunctionField className="ListIconsContainerMonthlyPassUsers" render={record => record &&
								<div className="ListIcons">
									<div>
										{allowRecharge && <RechargeButton {...props} record={record}/>}
									</div>
									<div>
										{allowEdit && <CustomEditButton {...props} record={record} />}
									</div>
									<div>
										{allowDelete && <CustomDeleteButton {...props} record={record} refresh={refresh} resourcePath={'v3/monthlyPass'} />}
									</div>
									<div>
										<Button title='Print Pass' onClick={() => handleShowPreview(record)} style={{ color: "#334d6e" }} label={false}>
											<PrintIcon/>
										</Button>
									</div>
									{record.qr_code &&
										<div>
											<Button title='Qr Code' onClick={() => download(record.qr_code)} style={{ color: "#334d6e" }} label={false}>
												<img src={QrCodeImg} alt='Qr Code' width={18} height={18} />
											</Button>
										</div>
									}
								</div>
							} />}
						</Datagrid>
					}
				</List>
			</>}

			{showPreview && showPreviewDetails && <PassPrinter isVisible={showPreview} showPreviewDetails={showPreviewDetails} onClose={handleClosePreview} />}
		</div>
	);
};

function EditButton(props) {
	//const notify = useNotify();
	const { record } = props;
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const [dialogVisible, setDialogVisible] = React.useState(false);
	const [vehicleNumber, setVehicleNumber] = React.useState("");
	const [mobileNumber, setMobileNumber] = React.useState("");
	const [valuesChanged, setValuesChanged] = React.useState(false);
	const [name, setName] = React.useState("");
	const [expiryDate, setExpiryDate] = React.useState(new Date());
	const openDialog = e => {
		e.stopPropagation();
		setVehicleNumber(record.vehicle_number);
		setMobileNumber(record.mobile_number);
		setName(record.name)
		setValuesChanged(false);
		setDialogVisible(true);
		setExpiryDate(record.expiry_date)
	};

	const closeDialog = () => {
		setDialogVisible(false);
	};

	const handleUpdate = (event) => {
		event.preventDefault();

		const { dispatchCrudUpdate, resource, record, basePath } = props;
		if (name.length === 0) {
			notify("Name cannot be empty", 'warning');
			return;
		}
		if (name !== name.trim()) {
			notify("Name must not start or end with a space", 'warning');
			return
		}
		if (/\s{2,}/.test(name)) {
			notify("Name must not contain multiple consecutive spaces", "warning")
			return
		}
		if (vehicleNumber.length === 0) {
			notify("Vehicle Number cannot be empty", 'warning');
			return;
		}
		if (mobileNumber.length === 0) {
			notify("Mobile Number cannot be empty", 'warning');
			return;
		}
		if (mobileNumber.length !== 10) {
			notify("Invalid Mobile Number", 'warning');
			return;
		}

		if(!moment(expiryDate).isValid()){
			notify("Invalid Validity", 'warning');
			return;
		}

		const data = {
			newData: {
				vehicle_number: vehicleNumber,
				mobile_number: mobileNumber,
				name: name,
				expiry_date: moment(expiryDate).format("YYYY-MM-DD HH:mm:ss")
			},
			oldData: record,
		};
		dispatchCrudUpdate(resource, record.id, data, record, basePath, "/monthlyPass");
		closeDialog();
	};

	const handleVehicleNumberChange = (event) => {
		if (event.target.value.length <= 200) {
			setVehicleNumber(event.target.value);
			setValuesChanged(true);
		}
	};

	const handleMobileNumberChange = (event) => {
		if (event.target.value.length <= 10) {
			setMobileNumber(event.target.value.replace(/[^0-9]/g, ""));
			setValuesChanged(true);
		}
	};

	const handleNameChange = (event) => {
		if (event.target.value.length <= 200) {
			setName(event.target.value);
			setValuesChanged(true);
		}
	};

	const handleDateChange = (date) => {
        setExpiryDate(date);
		setValuesChanged(true);
    };

	return (
		<>
			<RaButton onClick={openDialog} title="Edit" label={false}>
				<EditIcon />
			</RaButton>

			<Dialog fullWidth open={dialogVisible}>
				<DialogTitle>Edit Details</DialogTitle>
				<DialogContent style={{ display: "flex", flexDirection: "column" }}>
					<MuiTextField label="Name" variant="outlined" size="small" value={name} onChange={handleNameChange} />
					<MuiTextField label="Vehicle Number" variant="outlined" size="small" value={vehicleNumber} onChange={handleVehicleNumberChange} style={{ marginTop: 20 }} />
					<MuiTextField label="Mobile Number" variant="outlined" size="small" value={mobileNumber} onChange={handleMobileNumberChange} style={{ marginTop: 20 }} />
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<div id='expiryOperatorDateTimePicker' style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", columnGap: 20, rowGap: 2, width: 400, marginTop: 10, flexWrap: isSmallDevice ? 'wrap' : 'nowrap' }}>
							<KeyboardDatePicker
								margin="normal"
								id="date-picker-dialog"
								label="Validity Date"
								format="dd/MM/yyyy"
								inputVariant='outlined'
								value={expiryDate}
								onChange={handleDateChange}
								KeyboardButtonProps={{
									'aria-label': 'change date'
								}}
								InputProps={{
									disableUnderline: true,
								}}
								InputAdornmentProps={{ marginBottom: -20 }}
							/>
							<KeyboardTimePicker
								margin="normal"
								id="time-picker"
								format='HH:mm:ss'
								label="Validity Time"
								inputVariant='outlined'
								value={expiryDate}
								onChange={handleDateChange}
								KeyboardButtonProps={{
									'aria-label': 'change time'

								}}
							/>
						</div>
					</MuiPickersUtilsProvider>
				</DialogContent>
				<DialogActions>
					<Button onClick={closeDialog}>Cancel</Button>
					<Button onClick={handleUpdate} disabled={!valuesChanged}>Save</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

EditButton.defaultProps = {
	redirect: 'list',
	undoable: false
};

export const CustomEditButton = compose(
	connect(
		null,
		{ dispatchCrudUpdate: crudUpdate }
	),
	translate
)(EditButton);

function RechargeButton(props) {
	//const notify = useNotify();
	const refresh = useRefresh();
	const { record } = props;
	const { setIsChange } = useContext(ContextProvider);

	const [dialogVisible, setDialogVisible] = React.useState(false);
	const [loading, setLoading] = React.useState(false);

	const expiry = React.useRef(moment(record.expiry_date, "YYYY-MM-DD HH:mm:ss").toDate());
	const tempDate = React.useRef(new Date(expiry.current.valueOf()));

	const [startDate, setStartDate] = React.useState(new Date(expiry.current.setDate(expiry.current.getDate() + 1)));
	const [expiryDate, setExpiryDate] = React.useState(new Date(tempDate.current.setMonth(tempDate.current.getMonth() + 1)));
	const [price, setPrice] = React.useState(record.price);

	const openDialog = e => {
		e.stopPropagation();
		setDialogVisible(true);
	};

	const closeDialog = () => {
		setDialogVisible(false);
	};

	const rechargeMonthlyPass = (event) => {
		setIsChange(false)
		event.preventDefault();
		if (price === "" || price <= 0) {
			notify("Invalid Price", 'warning');
			return;
		}

		setLoading(true);
		const data = {
			parking_pass_id: record.id,
			user_id: sessionStorage.getItem("user_id"),
			start_date: moment(startDate).format("YYYY-MM-DD 00:00:00"),
			expiry_date: moment(expiryDate).format("YYYY-MM-DD 23:59:59"),
			price,
		};
		fetch(`${config.HOST_NAME}/crm/v3/rechargeMonthlyPass`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
			body: JSON.stringify(data)
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then(responseJson => {
				setLoading(false);
				closeDialog();
				if (responseJson.success) {
					refresh();
					notify(responseJson.message, "info");
				} else {
					notify(responseJson.message, 'warning');
				}
			})
			.catch((e) => {
				setLoading(false);
				closeDialog();
				notify('Error Recharging Monthly Pass', 'warning')
			});
	};

	return (
		<div style={{ textAlign: "center" }}>
			{/* <Button variant="outlined" color="primary" onClick={openDialog} style={{ fontSize: "0.8rem" }}>Recharge</Button> */}
			<RaButton onClick={openDialog} title="Recharge" label={false}>
				<PaymentIcon />
			</RaButton>

			<MuiPickersUtilsProvider utils={DateFnsUtils}>
				<Dialog fullWidth open={dialogVisible}>
					<Typography style={{ fontSize: 19, fontWeight: "bold", padding: "16px 24px" }}>Recharge Pass</Typography>
					<DialogContent style={{ display: "grid", gridRowGap: 20 }}>
						<DatePicker
							value={startDate}
							onChange={setStartDate}
							label="Start Date"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							format="dd-MM-yyyy"
						/>
						<DatePicker
							value={expiryDate}
							onChange={setExpiryDate}
							label="Expiry Date"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							format="dd-MM-yyyy"
							minDate={startDate}
						/>
						<MuiTextField
							variant="outlined"
							size="small"
							label="Price"
							value={price}
							onChange={(event) => {
								if (!isNaN(event.target.value))
									setPrice(event.target.value);
							}}
							maxLength={10}
						/>
					</DialogContent>
					<DialogActions>
						<Button onClick={closeDialog} disabled={loading}>Cancel</Button>
						<Button color="primary" onClick={rechargeMonthlyPass} disabled={loading}>{loading ? "Recharging..." : "Recharge"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
					</DialogActions>
				</Dialog>
			</MuiPickersUtilsProvider>
		</div>
	);
}

const defaultVehicleTypes = [
    { id: '2', name: 'Scooter' },
    { id: '4', name: 'Car' },
];
const defaultPassTypes = {
	"Scooter": [{type: "Day", prcie: 0}, {type: "Night", prcie: 0}, {type: "Day/Night", prcie: 0}],
	"Car": [{type: "Day", prcie: 0},{type: "Night", prcie: 0},{type: "Day/Night", prcie: 0}],
}

export const CreateMonthlyPass = ({ permissions, ...props }) => {
	const redirect = useRedirect();
	const onSuccess = () => {
        notify("Element Created", "success")
        redirect(props.basePath)
    }
    const onFailure = (error) => {
        notify(error.message, "warning")
    }
    return (<>
        <Helmet>
            <script src="https://checkout.razorpay.com/v1/checkout.js"></script>
        </Helmet>

		<Create {...props} title="Create Monthly Pass" onFailure={onFailure} onSuccess={onSuccess}>
			<SimpleForm redirect="list" validate={(values) => validateMonthlyPass(values)}>
				<div className="formLabel-bold" style={{ marginTop: 0 }}>Pass Details</div>
				<CustomFormField/>
				<div className="formLabel-bold" style={{ marginTop: 5 }}>Validity</div>
				<div className="grid-250" style={{ marginTop: 8 , marginBottom:40}}>
				<div>
					<div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Start Date*</div>
					<RaDateInput source="start_date"  label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} />
				</div>
				<div>
					<div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Expiry Date*</div>
					<RaDateInput source="expiry_date" expiryDate={true}  label="" placeholder="DD/MM/YYYY" style={{ marginTop: 7 }} />
				</div>
			</div>
            </SimpleForm>
        </Create>

    </>)
};

const CustomFormField = (props) =>{
	const { input: { value: model, onChange: setModel } } = useInput({ ...props, id: "model", source: "model" });
	const { input: { value: brand, onChange: setBrand } } = useInput({ ...props, id: "brand", source: "brand" });
	const { input: { value: accessKeyId, onChange: setAccessKeyId } } = useInput({ ...props, id: "accessKeyId", source: "accessKeyId" });
	const { input: { value: price, onChange: setPrice } } = useInput({ ...props, id: "price", source: "price" });
	const { input: { value: pass_type, onChange: set_pass_type } } = useInput({ ...props, id: "pass_type", source: "pass_type" });

	const [vehicleNumber, setVehicleNumber] = useState("");
	const [vehicleTypes, setVehicleTypes] = useState(null);
	const [vehicleTypesObj, setVehicleTypesObj] = useState(null)
	const [passTypes, setPassTypes] = useState(null);
	const [vehicleType, setVehicleType] = useState(null);
	const [bikeBrands, setBikeBrands] = useState([])
	const [carBrands, setCarBrands] = useState([])
	const [mobileNumber, setMobileNumber] = useState(null)

	const getCommonData = () => {

        fetch(
            `${config.HOST_NAME}/crm/commonData`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        )
            .then(response => response.json())
            .then(json => {
                setBikeBrands({ ...json.bikeBrands, Other: ["Other"] })
                setCarBrands({ ...json.carBrands, Other: ["Other"] })
            })
            .catch(error => {
                console.log(error);
                notify("Check your internet connection.", "warning")

            });
    };

	const onParkingSelect = async (accessKeyId) => {
        setAccessKeyId(accessKeyId)
    };

	const changeVehicleType = (vType) => {
		setVehicleType(vType);
		set_pass_type(null);
		setBrand(null);
		setModel(null);
	};

	useEffect(() => {
        if (accessKeyId) {
            fetch(`${config.HOST_NAME}/crm/v3/parkings?user_id=${sessionStorage.getItem("user_id")}&filter=${JSON.stringify({ id: [accessKeyId], includeSocieties: true })}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
                }
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then(json => {
                    if (json.success) {
						if(json.data[0].features && json.data[0].features.vehicle_type){
							const {features} = json.data[0]
							let vehTypes = Object.keys(features.vehicle_type).filter(type => features.vehicle_type[type].visible);
							let vehObj = {}
							let passTypeObj = features && features.monthly_pass && features.monthly_pass.pass_types ? features.monthly_pass.pass_types : defaultPassTypes
							setVehicleTypes(vehTypes.filter((type) => passTypeObj[features.vehicle_type[type].name]).map(type => { 
								vehObj[type] = features.vehicle_type[type].name
								return { id: type, name: features.vehicle_type[type].name, label: features.vehicle_type[type].label };
							}))
							setVehicleTypesObj(vehObj)
							setPassTypes(passTypeObj)
						}else {
							let vehObj = {}
							setVehicleTypes(defaultVehicleTypes.map(type => { 
								vehObj[type] = type.name
								return {id: type.id, name: type.name}
							}))
							setVehicleTypesObj(vehObj)
							setPassTypes(defaultPassTypes)
						}
                    } else setPrice(0)
                })
                .catch(error => {
                    //notify("Something went wrong", "warning");
                    console.log(error);
                });
        }
		 // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessKeyId]);

	useEffect(() => {
		setPrice(0)
        getCommonData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
	return <>

		<div className="grid-250">
			<div>
				<div className="formLabel-regular" style={{ position: "relative", top: 10 }}>Location*</div>
				<RaAutocompleteInput source="access_key_id" resourceParam="name" resourcePath="uniqueParkingAccessKeys" label="" getOptionValue={option => option["id"]} getOptionLabel={option => option["name"]} style={{ marginTop: 15, marginBottom: 25 }} onSelect={onParkingSelect} />
			</div>
		</div>
		<div className="grid-250">
			<div style={{ display: "flex", columnGap: 25 }}>
				<div>
					<div className="formLabel-regular" style={{ position: "relative" }}>Mobile Number*</div>
					<TextInput source="mobile_number" label="" variant="outlined" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} style={{ position: "relative", top: -5 }} />
				</div>
				<div>
					<div className="formLabel-regular">Gender</div>
					<RaGenderInput source="gender" style={{ position: "relative", top: 3 }} />
				</div>
			</div>
			<div>
				<div>
					<div className="formLabel-regular">Full Name</div>
					<TextInput source="name" label="" variant="outlined" style={{ position: "relative", top: -5 }} />
				</div>
			</div>
		</div>

		<div className="formLabel-bold" style={{ marginTop: 5 }}>Vehicle Details</div>
		{vehicleTypes &&
			<>
				<div className="grid-250" style={{ marginTop: 8 }}>
					<div>
						<div className="formLabel-regular" style={{ position: "relative", top: 3 }}>Vehicle Type*</div>
						<SelectInput variant="outlined" label="" source="vehicle_type" choices={vehicleTypes} optionText="label" optionValue="id" onChange={event => changeVehicleType(event.target.value)} style={{ display: "flex" }} />
					</div>

					{vehicleTypes && vehicleTypesObj && passTypes && vehicleTypesObj[vehicleType] &&
						<div style={{ marginBottom: 25 }}>
							<p className="formLabel-regular" style={{ lineHeight: "2px" }}>Pass Type</p>
							<MuiTextField
								className='inputRounded'
								size="small"
								variant='outlined'
								InputLabelProps={{ shrink: false }}
								style={{ width: "250px", marginTop: "2px" }}
								select
								value={pass_type}
								onChange={(event) => {
									set_pass_type(event.target.value)
									const passType = passTypes[vehicleTypesObj[vehicleType]].find(pass => pass.type === event.target.value);
									if(passType)
										setPrice(passType.price);
								}}
							>
								{
									passTypes[vehicleTypesObj[vehicleType]].map((val) => <MenuItem value={val.type} name={val.price}>{val.type}</MenuItem>)
								}
							</MuiTextField>
						</div>
					}
				</div>
			</>}

		<div className="grid-250" style={{ marginTop: 8 }}>
			<div>
				<div className="formLabel-regular" style={{ position: "relative" }}>Price*</div>
				<TextInput source="price" label="" variant="outlined" value={price} onChange={(e) => setPrice(e.target.value)} style={{ position: "relative", top: -5 }} />
			</div>
		</div>

		<div className="grid-250" style={{ marginTop: 8 }}>
			<div>
				<div className="formLabel-regular" style={{ position: "relative", top: 7, marginBottom: 5 }}>Vehicle Number*</div>
				<TextInput format={(value) => value && value.toUpperCase()} source="vehicle_number" label="" variant="outlined" value={vehicleNumber} onChange={(e) => {
					const caret = e.target.selectionStart
					const element = e.target
					window.requestAnimationFrame(() => {
						element.selectionStart = caret
						element.selectionEnd = caret
					})
					setVehicleNumber(e.target.value)
				}} onKeyDown={(e) => {
					if (e.code === 'Space') e.preventDefault()
				}} />
			</div>
			{
				vehicleType === "2" &&
				<div style={{ marginBottom: 25 }}>
					<p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
					<MuiTextField
						className='inputRounded'
						size="small"
						variant='outlined'
						InputLabelProps={{ shrink: false }}
						style={{ width: "250px", marginTop: "2px" }}
						select
						value={brand}
						onChange={(event) => setBrand(event.target.value)
						}
					>
						{
							Object.keys(bikeBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)
						}
					</MuiTextField>
				</div>
			}

			{
				vehicleType === "2" && brand && brand !== "Other" &&
				<div style={{ marginBottom: 25 }}>
					<p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
					<MuiTextField
						className='inputRounded'
						size="small"
						variant='outlined'
						InputLabelProps={{ shrink: false }}
						style={{ width: "250px", marginTop: "2px" }}
						select
						value={model}
						onChange={(event) => setModel(event.target.value)
						}
					>
						{
							bikeBrands[brand].map((val) => <MenuItem value={val}>{val}</MenuItem>)
						}
					</MuiTextField>
				</div>
			}

			{
				vehicleType === "4" &&
				<div style={{ marginBottom: 25 }}>
					<p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Brand</p>
					<MuiTextField
						className='inputRounded'
						size="small"
						variant='outlined'
						InputLabelProps={{ shrink: false }}
						style={{ width: "250px", marginTop: "2px" }}
						select
						value={brand}
						onChange={(event) => setBrand(event.target.value)
						}
					>
						{
							Object.keys(carBrands).map((val) => <MenuItem value={val}>{val}</MenuItem>)
						}
					</MuiTextField>
				</div>
			}


			{
				vehicleType === "4" && brand && brand !== "Other" &&
				<div style={{ marginBottom: 25 }}>
					<p className="formLabel-regular" style={{ lineHeight: "2px" }}>Select Model</p>
					<MuiTextField
						className='inputRounded'
						size="small"
						variant='outlined'
						InputLabelProps={{ shrink: false }}
						style={{ width: "250px", marginTop: "2px" }}
						select
						value={model}
						onChange={(event) => setModel(event.target.value)
						}
					>
						{
							carBrands[brand].map((val) => <MenuItem value={val}>{val}</MenuItem>)
						}
					</MuiTextField>
				</div>
			}
		</div>
	</>
}

const validateVehicleNumber = vehicleNumber => {
    if (vehicleNumber == null || vehicleNumber === "") {
        return "Vehicle Number is Required";
    } else if (vehicleNumber.length > 200) {
        return "Vehicle Number is too long";
    } else if (new RegExp("^[0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (new RegExp("^[a-zA-Z]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    else if (!new RegExp("^[A-Za-z0-9]*$").test(vehicleNumber)) {
        return "Invalid Vehicle Number";
    }
    return true;
};

const validateMonthlyPass = (values) => {

    const errors = {};

	if (values.access_key_id == null || values.access_key_id === "") {
		errors.access_key_id = 'Location is Required';
	} else if (values.pass_type == null || values.pass_type === "") {
		errors.pass_type = 'Pass Type is Required';
	} else if (values.mobile_number == null || values.mobile_number === "") {
		errors.mobile_number = 'Mobile Number is Required';
	} else if (values.mobile_number.search(/^\d{10}$/g) === -1) {
		errors.mobile_number = 'Invalid Mobile Number';
	}  else if (values.name == null || values.name === "") {
        errors.name = "Name is Required";
    } else if (values.name !== values.name.trim()) {
        errors.name = "Name must not start or end with a space";
    } else if (/\s{2,}/.test(values.name)) {
        errors.name = "Name must not contain multiple consecutive spaces";
    } else if (values.vehicle_number == null || values.vehicle_number === "") {
		errors.vehicle_number = "Vehicle Number is Required"
	}

    const vehicleNumberValidation = validateVehicleNumber(values.vehicle_number);
    if (!vehicleNumberValidation) {
        errors.vehicle_number = vehicleNumberValidation;
    }else if (values.vehicle_type == null || values.vehicle_type === "") {
        errors.vehicle_type = 'Vehicle Type is Required';
    } else if (values.price == null || values.price === "") {
        errors.price = 'Prcie is Required';
    } else if (values.start_date == null || values.start_date === "") {
        errors.start_date = 'Please specify the Start Date';
    } else if (values.expiry_date == null || values.expiry_date === "") {
        errors.expiry_date = 'Please specify the End Date';
    }
	
console.log(errors)
    return errors;
};


const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 14,
    fontFamily: 'Helvetica',
    display: 'flex',
    flexDirection: 'column',
	alignItems:"center"
  },
  header: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 30,
  },
  section: {
	marginLeft:"0px",
    padding: 15,
	width:"65%",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  row: {
    flexDirection: 'row',
    marginBottom: 40,
    width: '100%',
    justifyContent: 'center',
  },
  label: {
    width: 150,
    fontWeight: 'bold',
    textAlign: 'left',
    marginRight: 10,
  },
  value: {
    flex: 1,
    textAlign: 'left',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    fontSize: 10,
    color: '#555',
    textAlign: 'center',
    width: '100%',
  },
  logoContainer: {
    position: 'absolute',
    bottom: 20, // Position the logo at the bottom
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center', // Center the logo horizontally
  },
  logo: {
    width: 60, // Adjust the width as needed
    height: 25, // Adjust the height as needed
  },
});

const PassDocument = ({ content }) => {
  const pageSizes = {
    A4: [595.28, 841.89],
  };

  return (
    <Document>
      <Page size={pageSizes.A4} style={styles.page}>
        <Text style={styles.header}>{content.parkingName}</Text>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Name:</Text>
            <Text style={styles.value}>{content.name}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Vehicle Number:</Text>
            <Text style={styles.value}>{content.vehicleNumber}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Vehicle Type:</Text>
            <Text style={styles.value}>{content.vehicleType}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Pass Amount:</Text>
            <Text style={styles.value}>{content.passAmount}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Mobile Number:</Text>
            <Text style={styles.value}>{content.mobileNumber}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Validity:</Text>
            <Text style={styles.value}>{content.validity}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Renew Date:</Text>
            <Text style={styles.value}>{content.renewDate}</Text>
          </View>
        </View>
		<View style={styles.logoContainer}>
          <Image src={PSBLogo} style={styles.logo} />
        </View>
		
      </Page>
    </Document>
  );
};

const PassPrinter = ({ isVisible, showPreviewDetails, onClose }) => {
	const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        return moment(time).utcOffset("+05:30").format(`DD MMM YYYY ${use24HourFormat ? `HH:mm${secondsFormat} A` : `hh:mm${secondsFormat} a`}`)
	};
	const passContent = {
		parkingName: showPreviewDetails?.parking_name || "-",
		name: showPreviewDetails?.name || "-",
		vehicleNumber: showPreviewDetails?.vehicle_number || "-",
		vehicleType: showPreviewDetails && showPreviewDetails.vehicle_type ? AnalyticDistributionImgs[showPreviewDetails.vehicle_type]?.label || "-" : "-",
		passAmount: showPreviewDetails && showPreviewDetails.price ? `${showPreviewDetails.price} Rupees` : "0 Rupees",
		mobileNumber: showPreviewDetails?.mobile_number || "-",
		validity: showPreviewDetails && showPreviewDetails.expiry_date ? renderTime(showPreviewDetails.expiry_date) : "-",
		renewDate:  showPreviewDetails && showPreviewDetails.last_start_date ? renderTime(showPreviewDetails.last_start_date) : "-",
	};

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        className="pdf-viewer-container"
        style={{
			width: '100vw',
			height: '100vh',
          backgroundColor: '#fff',
          borderRadius: '10px',
          overflow: 'hidden',
        }}
      >
        <PDFViewer width="100%" height="100%" showToolbar={true}>
          <PassDocument content={passContent} />
        </PDFViewer>
      </div>
      <button
        onClick={onClose}
        style={{
          marginTop: '10px',
          padding: '10px 20px',
          backgroundColor: '#dc3545',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
		  position: 'absolute',
			bottom: 20,
			right: 30
        }}
      >
        Close
      </button>
    </div>
  );
};